import React, { Component } from 'react';

import './TimeInput.scss';

class TimeInput extends Component {
  constructor(props) {
    super(props);
    const [Hours, Minutes] = props.initTime.split(':');

    this.state = {
      TempValues: {},
      HoursSelected: Hours || '8',
      MinutesSelected: Minutes || '00',
      PastMidday: (parseInt(Hours, 10) > 12),
    };

    this.incrementHours = this.incrementHours.bind(this);
    this.incrementMinutes = this.incrementMinutes.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSwapNight = this.handleSwapNight.bind(this);
    this.handleTempValue = this.handleTempValue.bind(this);
    this.handleMinutesBlur = this.handleMinutesBlur.bind(this);
    this.handleHoursBlur = this.handleHoursBlur.bind(this);
  }

  Convert24Hour(Time) {
    let TempTime = Time;

    if (typeof Time === 'string') {
      TempTime = parseInt(Time);
    }

    if (TempTime === 0) {
      return '12';
    }

    if (TempTime > 12) {
      return ('00' + (TempTime - 12)).slice(-2);
    }

    return ('00' + Time).slice(-2);
  }

  handleChange(hours, mins) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          value: (hours + ':' + mins),
        },
      });
    }
  }

  incrementHours(direction, newMins = null) {
    return event => {
      const currentTime = parseInt(this.state.HoursSelected);
      let newTime = currentTime + direction;

      if (newTime >= 24) {
        this.setState({
          HoursSelected: 24,
          MinutesSelected: 0,
          PastMidday: true,
        });
        this.handleChange(24, 0);
      } else {
        if (newTime < 0) {
          newTime = 0;
        }

        this.setState({
          HoursSelected: newTime,
          PastMidday: (newTime >= 12),
        });
        this.handleChange(newTime, newMins || this.state.MinutesSelected);
      }
    };
  }

  incrementMinutes(direction) {
    return event => {
      const currentMins = parseInt(this.state.MinutesSelected);
      let newMins = currentMins + (15 * direction);

      if (newMins >= 60 || newMins < 0) {
        newMins = (newMins >= 60) ? '00' : '45';

        this.setState({
          MinutesSelected: newMins,
        });

        this.incrementHours(direction, newMins)();
        return;
      }

      this.setState({
        MinutesSelected: newMins,
      });

      this.handleChange(this.state.HoursSelected, newMins);
    };
  }

  handleSwapNight() {
    const currentHours = parseInt(this.state.HoursSelected);
    let newHours = (currentHours + 12).toString();

    if (currentHours > 12) {
      newHours = (currentHours - 12).toString();

      this.setState({
        HoursSelected: newHours,
        PastMidday: false,
      });
    } else {
      this.setState({
        HoursSelected: newHours,
        PastMidday: true,
      });
    }

    this.handleChange(newHours, this.state.MinutesSelected);
  }

  handleTempValue(name) {
    return event =>
      this.setState({
        TempValues: Object.assign({}, this.state.TempValues, {
          [name]: event.target.value,
        })
      });
  }

  handleHoursBlur() {
    if (Object.prototype.hasOwnProperty.call(this.state.TempValues, 'Hours')) {
      if (parseInt(this.state.TempValues.Hours) > 0 && parseInt(this.state.TempValues.Hours) <= 12) {
        this.handleChange(this.state.TempValues.Hours, this.state.MinutesSelected);
        this.setState({
          TempValues: {},
          HoursSelected: this.state.TempValues.Hours,
        });
        return;
      }
    }
    this.setState({
      TempValues: {},
    });
  }

  handleMinutesBlur() {
    if (Object.prototype.hasOwnProperty.call(this.state.TempValues, 'Minutes')) {
      if (parseInt(this.state.TempValues.Minutes) > 0 && parseInt(this.state.TempValues.Minutes) < 60) {
        let newMinutes = ((Math.round((parseInt(this.state.TempValues.Minutes)) / 15)) * 15);

        if (newMinutes >= 60) {
          newMinutes = 0;
        }

        console.log((('00' + newMinutes.toString()).slice(-2)));

        this.setState({
          TempValues: {},
          MinutesSelected: (('00' + newMinutes.toString()).slice(-2)),
        });
        this.handleChange(this.state.HoursSelected, (('00' + newMinutes.toString()).slice(-2)));
        return;
      }
    }
    this.setState({
      TempValues: {},
    });
  }

  render() {
    console.log(this.state);
    return (
      <div className='TimeInput__Wrapper'>
        <div className='row'>
          <div className='col-5'>
            <a className='TimeInput__UpButton' onClick={this.incrementHours(1)}>+</a>
            <input onChange={this.handleTempValue('Hours')} value={this.state.TempValues.Hours || this.Convert24Hour(this.state.HoursSelected)}
              type='number' className='TimeInput__Input' onBlur={this.handleHoursBlur} />
            <a className='TimeInput__UpButton' onClick={this.incrementHours(-1)}>-</a>
          </div>
          <div className='col-5'>
            <a className='TimeInput__UpButton' onClick={this.incrementMinutes(1)}>+</a>
            <input onChange={this.handleTempValue('Minutes')} value={this.state.TempValues.Minutes || this.state.MinutesSelected}
              type='number' className='TimeInput__Input' onBlur={this.handleMinutesBlur} />
            <a className='TimeInput__UpButton' onClick={this.incrementMinutes(-1)}>-</a>
          </div>
          <div className='col-2'>
            <div className='TimeInput__AMShift'>
              <span onClick={this.handleSwapNight}><div>{(this.state.PastMidday) ? 'PM' : 'AM'}</div></span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TimeInput.defaultProps = {
};

export default TimeInput;



// WEBPACK FOOTER //
// ./src/routes/scheduler/routes/ViewScheduler/components/TimeInput/index.js